export default {
    PROJECT_DETAILS: "Проект"
};
